var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { ApprovedGateViewDescription } from './ApprovedGateViewDescription/ApprovedGateViewDescription';
import styles from './ApprovedGateView.module.scss';
import { ApprovedChecklists } from './ApprovedChecklists/ApprovedChecklists';
import { observable, action } from 'mobx';
import { Api } from '@app/Api';
import { observer } from 'mobx-react';
import { Loader } from '@app/Components/Loader/Loader';
import { withRouter } from 'react-router-dom';
import { ProjectStateContext } from '@app/Pages/ProjectView/Components/ProjectStateContext';
var ApprovedGateViewC = /** @class */ (function (_super) {
    __extends(ApprovedGateViewC, _super);
    function ApprovedGateViewC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._gate = null;
        _this.loading = false;
        return _this;
    }
    ApprovedGateViewC.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gateId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gateId = this.props.gateId;
                        return [4 /*yield*/, this._getGate(gateId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ApprovedGateViewC.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var gateId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gateId = this.props.gateId;
                        if (!(prevProps.gateId !== gateId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._getGate(gateId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ApprovedGateViewC.prototype._getGate = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = this;
                        return [4 /*yield*/, Api.secured.getGate({ id: id })];
                    case 2:
                        _a._gate = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApprovedGateViewC.prototype.render = function () {
        var _this = this;
        var _a = this.props, projectId = _a.projectId, projectCodeName = _a.projectCodeName, projectHasOnlyMasterCheckLists = _a.projectHasOnlyMasterCheckLists;
        if (this.loading) {
            return (React.createElement("div", { className: styles.loader },
                React.createElement(Loader, { style: { width: 100, height: 100 } }),
                ' '));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ProjectStateContext.Consumer, null, function (projectState) {
                if (!_this._gate)
                    return null;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.description },
                        React.createElement(ApprovedGateViewDescription, { gate: _this._gate })),
                    React.createElement(ApprovedChecklists, { projectId: projectId, projectCodeName: projectCodeName, gateId: _this._gate.id, gateCodeName: _this._gate.displayName, projectHasOnlyMasterCheckLists: projectHasOnlyMasterCheckLists, hideNAItems: projectState.hideNAItems, isProjectTerminatedOrCompleted: projectState.isProjectTerminatedOrCompleted })));
            })));
    };
    __decorate([
        observable
    ], ApprovedGateViewC.prototype, "_gate", void 0);
    __decorate([
        observable
    ], ApprovedGateViewC.prototype, "loading", void 0);
    __decorate([
        action.bound
    ], ApprovedGateViewC.prototype, "_getGate", null);
    ApprovedGateViewC = __decorate([
        observer
    ], ApprovedGateViewC);
    return ApprovedGateViewC;
}(React.Component));
export var ApprovedGateView = withRouter(ApprovedGateViewC);
